import React, { ReactElement } from 'react';
import { Alert } from 'b2b-components/theme/components/Alert';
import { AddItemsToCartContentDoneProps, ContentControlButtons } from 'b2b-apps/shop/common/components';
import './AddItemsToCartContentDone.scss';

export const AddItemsToCartContentDone = ({
  text,
  failedItemsGroups,
  onClose,
  numberOfAddedCartItems,
  onConfirm,
  onProductClick,
}: AddItemsToCartContentDoneProps): ReactElement => (
  <>
    <h5 className='ContentDone-Title'>{text.operationComplete}</h5>

    <div className='Modal-ContentAlert'>
      {!!numberOfAddedCartItems && (
        <Alert
          displayType={Alert.config.displayType.text}
          styleType={Alert.config.styleType.success}
        >
          {text.addingItemsComplete}
        </Alert>
      )}

      {failedItemsGroups.map((group, index) => (
        <div key={index}>
          <Alert
            displayType={Alert.config.displayType.text}
            styleType={Alert.config.styleType.warning}
            className="ContentDone-Description ContentDone-Description--Warning"
          >
            {group.description}
          </Alert>

          <ul className="ContentDone-List">
            {group.items.map((item) => (
              <li className="ContentDone-ListItem" key={item.sku}>
                <span className="ContentDone-ListItemSku">{text.articleNr} {item.sku}</span>
                <span className="ContentDone-ListItemName" onClick={onProductClick(item.sku)}>{item.title}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}

      {!!failedItemsGroups.length && !numberOfAddedCartItems && (
        <Alert
          displayType={Alert.config.displayType.text}
          styleType={Alert.config.styleType.error}
        >
          {text.addingItemsFailed}
        </Alert>
      )}
    </div>

    <ContentControlButtons
      onClose={onClose}
      closeLabel={text.close}
      onConfirm={onConfirm}
      confirmLabel={text.approveSuccess}
      hideConfirmButton={!numberOfAddedCartItems}
    />
  </>
);
